var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18M15 18C15 16.3431 13.6569 15 12 15M15 18H21M9 18C9 16.3431 10.3431 15 12 15M9 18H3M12 15V12M9.6 12C7.61177 12 6 10.46 6 8.56026C6 6.98576 7.2 5.53125 9 5.25C9.56463 3.95553 10.9009 3 12.4595 3C14.456 3 16.0878 4.49304 16.2 6.375C17.2595 6.82171 18 7.91806 18 9.10513C18 10.7039 16.6569 12 15 12L9.6 12Z",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.e923290af76d3d7dba7589983ab25dc8.svg";
export { ForwardRef as ReactComponent };